import { render, staticRenderFns } from "./table-data.vue?vue&type=template&id=7a376f61&"
import script from "./table-data.vue?vue&type=script&lang=js&"
export * from "./table-data.vue?vue&type=script&lang=js&"
import style0 from "./table-data.vue?vue&type=style&index=0&id=7a376f61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports